// src/features/services/agent/components/AgentDashboard.tsx
// ─────────────────────────────────────────────────────────────────────────────
// Agent — zero-prop top-level dashboard.
// Owns no state from App.tsx; delegates to CreateThreadPanel + ThreadList.
// PAC Glass design system.
// ─────────────────────────────────────────────────────────────────────────────
import React, { useState, useCallback } from 'react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import CreateThreadPanel from './CreateThreadPanel';
import ThreadList from './ThreadList';

export default function AgentDashboard() {
  useDocumentTitle('Agent — SKU Builder');

  // Coordinate: auto-expand the newest thread after creation
  const [autoExpandKey, setAutoExpandKey] = useState<string | null>(null);

  const handleThreadCreated = useCallback((threadKey: string) => {
    setAutoExpandKey(threadKey);
  }, []);

  return (
    <section className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-neutral-100">Agent</h1>
        <span className="text-[10px] text-neutral-600 uppercase tracking-wider">
          AI-Powered SKU Builder
        </span>
      </div>

      <CreateThreadPanel onThreadCreated={handleThreadCreated} />
      <ThreadList autoExpandKey={autoExpandKey} />
    </section>
  );
}
